import { gql } from '@apollo/client';

export const UPDATE_DEPOSIT_ORDER = gql`
  mutation updatePayPalOrder($id: String!) {
    updatePayPalOrder(id: $id) {
      id
    }
  }
`;
